import { OfflineScreenEvent } from '@/types/api/login';
import config from '@/config';
import http from '@/utils/http';
import { AxiosResponse } from 'axios';

export async function getOfflineScreenEvents(
  screenIdentifier: string,
): Promise<OfflineScreenEvent> {
  const response = await http.get<OfflineScreenEvent>(
    `${config.apiUrl}userapi/offline-screen-events?screen_identifier=${encodeURIComponent(
      screenIdentifier,
    )}`,
    {
      'axios-retry': {
        retries: 0,
      },
    },
  );
  return response.data;
}

export async function updateOfflineScreenEvents(
  screenIdentifier: string,
  patchRequest: Record<string, string | boolean>,
): Promise<AxiosResponse> {
  const response = await http.patch<AxiosResponse>(
    `${config.apiUrl}userapi/offline-screen-events`,
    {
      ...patchRequest,
      screen_identifier: screenIdentifier,
    },
  );
  return response.data;
}

export async function uploadOfflineScreenshot(screenshotBase64: string, screenIdentifier: string) {
  const response = await http.post<AxiosResponse>(`${config.apiUrl}userapi/offline-screenshot`, {
    screenshot: screenshotBase64,
    timestamp: new Date().toISOString(),
    screen_identifier: screenIdentifier,
  });
  return response.data;
}
